import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import _ from "lodash";
import http from "../services/http";
import UserContext from "../context/userContext";

const Home = () => {
  const [user] = useContext(UserContext);

  const [activeOperations, setActiveOperations] = useState([]);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    async function getOperation() {
      const { data } = await http.get(`/operations`);
      const active = data.filter(
        (operation) =>
          moment(operation.START_DATE) < moment() &&
          moment(operation.END_DATE) > moment()
      );
      setActiveOperations(_.sortBy(active, ["SITE"]));
    }

    async function getAlerts() {
      try {
        const { data } = await http.get(`/alerts`);
        setAlerts(data);
      }
      catch {
        //ignore error
      }
    }

    if (user) {
      getOperation();
    }
    if (user) {
      getAlerts();
    }
  }, [user]);

  function getWelcome() {
    // Month is 0 to 11
    if (moment().date() === 31 && moment().month() === 9)
      return `Happy Halloween`;
    if (moment().date() === 25 && moment().month() === 11)
      return "Merry Christmas";
    return `Welcome`;
  }

  moment.updateLocale("en", {
    calendar: {
      sameElse: "Do MMMM YYYY hh:mma",
    },
  });

  var welcome = getWelcome();

  if (user) welcome += ` ${user.FIRST_NAME}`;

  return (
    <div className="col mt-4">
      <div className="row">
        <div className="col">
          {alerts.map((alert) => (
            <div
              key={alert.ALERT_ID}
              className={"alert alert-" + alert.ALERT_TYPE}
              role="alert"
            >
              {alert.MESSAGE}
              <br />
              <small className="text-muted">
                {moment(alert.DATE_CREATED).calendar()}
              </small>
            </div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h1>{welcome} <span role="img" aria-label="clapping hand">👋</span></h1>
        </div>
      </div>
      <div className="row">
        {activeOperations
        ? activeOperations.map((operation) => (
          <div key={operation.OPTN_CODE} className="col-auto py-3">
            <div
              className={
                moment(operation.END_DATE).diff(moment(), "days") > 10
                  ? "card text-white bg-dark"
                  : "card text-white bg-danger"
              }
            >
              <div className="card-body">
                <h3 className="card-title display-3 text-right pb-0 mb-0">
                  {moment(operation.END_DATE).diff(moment(), "days")}
                </h3>
                <h6 className="card-subtitle text-right">Days Remaining</h6>
                <p className="card-text lead" style={{ fontSize: "1.5rem" }}>
                  {operation.COMMENTS}
                </p>
              </div>
            </div>
          </div>
        ))
        : <div />
      }
      </div>
    </div>
  );
};

export default Home;
